<div>
    @let state = $applicationState();
    <div>
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h1>{{ $bookingOption()?.title }}</h1>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <rsr-loading [loaded]="$loaded()"></rsr-loading>
          <rsr-loading [loaded]="!$operationInProgress()" text="Operation in progress.."></rsr-loading>
          @if ($loaded()) {
            @if (!$applicationState().capacityAvailable) {
              <rsr-alert variant="error">
                <p i18n>We're sorry there is no longer any availability for this booking.</p>
              </rsr-alert>
            }
            @if (!$applicationState().isEligible) {
                <rsr-alert variant="error">
                  <p i18n>You are not eligible to apply for this booking.</p>
                </rsr-alert>
            }

            @if (state.showApply) {
              <rsr-alert variant="primary">
                <p i18n>You are eligible to apply for this booking.</p>
              </rsr-alert>
            }

            @if (!$canApply()) {
              <rsr-alert variant="warn">
                <p i18n>Currently closed to applications</p>
              </rsr-alert>
            }
          }
        </mat-card-content>
      </mat-card>


      @if ($loaded()) {
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h2 i18n>Details</h2>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if ($error()) {
            <rsr-alert variant="error">
              <p>{{ $error() }}</p>
            </rsr-alert>
          }
          @let bookingOption=$bookingOption();
          @if (bookingOption) {
              <ul>
                <li><span i18n>Status:</span>
                  @if ($canApply()) {
                    <app-badge variant="success" i18n-title title="Open"></app-badge>
                  } @else {
                    <app-badge variant="warning" i18n-title title="Closed"></app-badge>
                  }
                </li>
                <li><span i18n>Booking item</span>: {{ bookingOption.bookingItem.name }}</li>
                @if (bookingOption.venue) {
                  <li><span i18n>Where:</span> {{ bookingOption.venue?.name }}</li>
                }
                @if (bookingOption.summary?.bookingDates.min) {
                  <li><span i18n>When:</span>
                    {{ bookingOption.summary?.bookingDates | easDateRange: timezone: bookingOption.summary.bookingDates?.timezone }}
                  </li>
                }
                @if (bookingOption.summary?.bookingWindow.min) {
                  <li><span i18n>Apply from:</span>
                    {{ bookingOption.summary?.bookingWindow | easDateRange: timezone: bookingOption.summary.bookingWindow?.timezone }}
                  </li>
                }
                @if (bookingOption.summary?.price.min) {
                  <li><span i18n>Price:</span>
                    <span>{{ bookingOption.summary.price| easPriceRange: bookingOption.summary.price.currency }}</span>
                  </li>
                }
                @if (bookingOption?.capacity?.available !== -1) {
                  <li i18n>Available capacity: {{ bookingOption?.capacity?.free }}</li>
                }
              </ul>
          }

        </mat-card-content>
      </mat-card>

      @if (state.eligibilityTree) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              <h2 i18n>Eligibility requirements</h2>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
              <p>{{ state.eligibilityDescription }}</p>
              @if (!state.isEligible) {
                <app-badge
                  variant="warning"
                  icon="close"
                  size="lg"
                  title="Not eligible"
                  i18n-title>
                </app-badge>

                @if (state.hasEligibilityTree) {
                  <div class="mt-2">
                  @if ($viewEligibility()) {
                    <div class="mb-2">
                      <eas-eligibility-view [eligibility]="state.eligibilityTree"></eas-eligibility-view>
                    </div>
                    <button mat-stroked-button (click)="toggleViewEligibility()" i18n>Hide eligibility</button>
                  } @else {
                    <button mat-stroked-button (click)="toggleViewEligibility()" i18n>Why am I not eligible?</button>
                  }
                  </div>
                }
              } @else {
                <app-badge
                  variant="success"
                  icon="check"
                  size="lg"
                  title="Eligible"
                  i18n-title>
                </app-badge>
              }
            </mat-card-content>
        </mat-card>
      }

      <mat-card>
        <mat-card-actions>
          <ub-button-list>
          <ng-container>
          @if (state.showApply) {
            <button mat-flat-button color="primary" (click)="onApply()" i18n>Apply</button>
          }

          @if (state.showForceApply) {
            <button mat-flat-button color="primary" (click)="onApply(true)" i18n>Force Apply</button>
          }

          @if (!state.showApply && !$operationInProgress()) {
            <a mat-flat-button color="primary" [routerLink]="['/bookings', 'available']" i18n>Show me available bookings</a>
          }
          </ng-container>
          </ub-button-list>
        </mat-card-actions>
    </mat-card>


      @if ($tableLoaded()) {
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h2 i18n>Similar booking applications</h2>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p i18n>You have already applied for these bookings of this type</p>
          <eas-interactive-table [options]="tableComponentOptions"></eas-interactive-table>
        </mat-card-content>
      </mat-card>
      }
      }
    </div>
</div>
